import { FC, memo, useContext, useEffect, useState } from "react";
import { CountdownTimerContext } from "../../../components";
import { MatchStatus } from "../../../service";
import { getTeamColors } from "../../../components/colors";
import { Text } from "components/common/Text";
import { TwoTeamScoreBoard } from "../../../components/common";

const TIMER_PAUSE_EVENTS: string[] = ["1015", "1019", "1021", "1022", "1017"];
const TIMER_HIDE_EVENTS: string[] = ["1015", "1016", "1017", "1018"];

export const Timer: FC<{ status: MatchStatus }> = memo(
  ({
    status: {
      nsc,
      c: {
        GOAL: [homeScore, awayScore],
      },
      tm,
      ta,
      ...status
    },
  }) => {
    const [isExtraTime, setIsExtraTime] = useState(false);
    const { minutes, seconds, pauseTimer, continueTimer, setDirection } =
      useContext(CountdownTimerContext);

    const taNum = Number(ta);
    const hasTa = Number.isFinite(taNum) && taNum > 0;

    const extraText = hasTa ? `+${taNum}` : isExtraTime ? "E.T" : null;

    useEffect(() => {
      if (tm > 0) {
        setDirection(+1);
      } else {
        setDirection(-1);
      }
    }, [setDirection, continueTimer, tm]);

    useEffect(() => {
      if (nsc && TIMER_PAUSE_EVENTS.includes(nsc)) pauseTimer();
      else continueTimer();
    }, [nsc, pauseTimer, continueTimer]);

    useEffect(() => {
      if (nsc === "1026") {
        setIsExtraTime(true);
      } else if (nsc && ["1015", "1016", "1017", "1018"].includes(nsc)) {
        setIsExtraTime(false);
      }
    }, [nsc]);

    const shouldHideTimer = nsc && TIMER_HIDE_EVENTS.includes(nsc);

    const { home: homeColor, away: awayColor } = getTeamColors(status as any);

    return (
      <div
        className="absolute top-0 flex -translate-x-1/2 flex-col items-start justify-center"
        style={{ left: isExtraTime ? "53%" : "50%", marginTop: "0.5vw" }}
      >
        <TwoTeamScoreBoard
          className="h-[6vw]"
          width="11vw"
          scoreHeight="6vw"
          accentHeight="0.5vw"
          gap="0.2vw"
          columnGap="0.2vw"
          homeAccentColor={homeColor}
          awayAccentColor={awayColor}
          homeContent={homeScore}
          awayContent={awayScore}
        />
        {!shouldHideTimer && (
          <div className="mt-[0.2vw] flex items-center justify-center">
            <div className="flex h-[4vw] w-[11vw] items-center justify-center bg-black/80 text-center font-bold text-white">
              <Text variant="soccerTimer">
                <span>{minutes}</span>
                <span>:</span>
                <span>{Number(seconds) < 10 ? `${seconds}` : seconds}</span>
              </Text>
            </div>
            {(isExtraTime || hasTa) && (
              <div className="ml-[0.3vw] flex h-[4vw] w-[6vw] items-center justify-center text-center font-bold text-white bg-red">
                <Text variant="soccerTimer">{extraText}</Text>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
);
